'use strict'

// A sample component

const ImageCursor = {
    init: function () {
        ImageCursor.plus = document.querySelector('.c-dynamiqueImage_button');
        ImageCursor.container = document.querySelector('.c-dynamiqueImage_container');
        if (ImageCursor.container) {
            this.cursorCustom();
        }
    },

    cursorCustom: function () {
        ImageCursor.plus.onclick = function() {
            ImageCursor.container.classList.toggle('open');
        };
    }
}


export default ImageCursor;


// WEBPACK FOOTER //
// ./src/scripts/components/ImageCursor.js